import isFunction from 'lodash/isFunction';
import * as issueViewFeatureFlagsModule from '@atlassian/jira-issue-view-feature-flags';

export const getIssueViewFeatureFlags = () => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const featureFlagReport: Record<string, any> = {};
	Object.entries(issueViewFeatureFlagsModule).forEach(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		([featureFlagName, featureFlagFunc]: [any, any]) => {
			if (isFunction(featureFlagFunc)) {
				featureFlagReport[featureFlagName] = featureFlagFunc();
			}
		},
	);
	return featureFlagReport;
};
